module.exports = __webpack_public_path__ + "images/feature/20170214_1-3555442c426f47075987af6dc43327c1.jpg";